import styled from 'styled-components';

export default styled.div`
  color: #44444f;
  font-size: 11px;
  font-weight: 600;
  line-height: 17px;
  text-transform: uppercase;
`;
